import { BrokerService } from './broker.model';

const REGEX_LITERAL = /^\/([\s\S]*)\/([a-z]*)$/;

function toRegExp(pattern: string): RegExp | undefined {
	const literal = REGEX_LITERAL.exec(pattern);
	try {
		return literal ? new RegExp(literal[1], literal[2]) : new RegExp(pattern);
	} catch {
		return undefined;
	}
}

function readPath(target: object, path: string): unknown {
	return path
		.replace(/^\$\.?/, '')
		.split('.')
		.filter(Boolean)
		.reduce<unknown>((value, segment) => {
			if (value === null || typeof value !== 'object') return undefined;
			return (value as Record<string, unknown>)[segment];
		}, target);
}

export function matchesServiceRegexFilter(service: BrokerService, target: object): boolean {
	const regexFilter = service?.regexFilter;
	if (!regexFilter) return true;

	return Object.entries(regexFilter).every(([path, pattern]) => {
		if (pattern === undefined) return true;
		const regExp = toRegExp(pattern);
		const value = readPath(target, path);
		if (!regExp || (typeof value !== 'string' && typeof value !== 'number')) return false;
		return regExp.test(String(value));
	});
}
